import {
  LayoutDashboard,
  Users,
  ShieldCheck,
  Store,
  Package,
  FolderTree,
  Tags,
  Contact,
  ListTodo,
  Truck,
  Sparkles,
  Boxes,
  Bot,
  Workflow,
  Activity,
  ThumbsUp,
  BookOpen,
  FileText,
  Scale,
  XCircle,
  BarChart3,
  ScrollText,
  ShieldAlert,
  Bug,
  Bell,
  Settings,
  HeartPulse,
  KeyRound,
  UserCircle
} from 'lucide-react';

/**
 * Sidebar configuration for the admin layout.
 *
 * Items can be flat or grouped under a `section` label (rendered as a
 * subtle uppercase header). Each item carries an optional `perm` for
 * UX gating; the server enforces the same checks anyway.
 */
export const ADMIN_NAV = [
  {
    section: 'Panoramica',
    items: [
      { to: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard },
      { to: '/admin/analytics', label: 'Analytics', icon: BarChart3, perm: 'analytics:read' }
    ]
  },
  {
    section: 'Organizzazione',
    items: [
      { to: '/admin/users', label: 'Utenti', icon: Users, perm: 'users:read' },
      { to: '/admin/roles', label: 'Ruoli', icon: ShieldCheck, perm: 'roles:read' },
      { to: '/admin/stores', label: 'Negozi', icon: Store, perm: 'stores:read' }
    ]
  },
  {
    section: 'Catalogo',
    items: [
      { to: '/admin/products', label: 'Prodotti', icon: Package, perm: 'products:read' },
      { to: '/admin/categories', label: 'Categorie', icon: FolderTree, perm: 'products:read' },
      { to: '/admin/brands', label: 'Brand', icon: Tags, perm: 'products:read' }
    ]
  },
  {
    section: 'Relazioni',
    items: [
      { to: '/admin/customers', label: 'Clienti', icon: Contact, perm: 'customers:read' }
    ]
  },
  {
    section: 'Operatività',
    items: [
      { to: '/admin/tasks', label: 'Attività', icon: ListTodo, perm: 'tasks:read' },
      { to: '/admin/logistics', label: 'Logistica', icon: Truck, perm: 'logistics:read' }
    ]
  },
  {
    section: 'AI',
    items: [
      { to: '/admin/ai/personality', label: 'Personalità', icon: Sparkles, perm: 'ai:configure' },
      { to: '/admin/ai/agents', label: 'Agenti', icon: Workflow, perm: 'ai:configure' },
      { to: '/admin/ai/models', label: 'Modelli', icon: Boxes, perm: 'ai:configure' },
      { to: '/admin/ai/playground', label: 'Playground', icon: Bot, perm: 'ai:test' },
      { to: '/admin/ai/usage', label: 'Consumi', icon: Activity, perm: 'analytics:read' },
      { to: '/admin/ai/feedback', label: 'Feedback', icon: ThumbsUp, perm: 'analytics:read' },
      { to: '/admin/ai/jailbreak', label: 'Test sicurezza', icon: Bug, perm: 'ai:configure' },
      { to: '/admin/rag', label: 'Knowledge base', icon: BookOpen, perm: 'rag:read' }
    ]
  },
  {
    section: 'Conformità',
    items: [
      { to: '/admin/privacy/register', label: 'Registro art. 30', icon: FileText, perm: 'privacy:read' },
      { to: '/admin/privacy/consents', label: 'Consensi', icon: Scale, perm: 'privacy:read' },
      { to: '/admin/privacy/erasures', label: 'Cancellazioni', icon: XCircle, perm: 'privacy:read' }
    ]
  },
  {
    section: 'Sistema',
    items: [
      { to: '/admin/clients', label: 'Client API', icon: KeyRound, perm: 'clients:read' },
      { to: '/admin/logs', label: 'Log', icon: ScrollText, perm: 'logs:read' },
      { to: '/admin/security', label: 'Sicurezza', icon: ShieldAlert, perm: 'security:manage' },
      { to: '/admin/notifications', label: 'Notifiche', icon: Bell, perm: 'notifications:read' },
      { to: '/admin/settings', label: 'Impostazioni', icon: Settings, perm: 'settings:read' },
      { to: '/admin/system', label: 'Stato', icon: HeartPulse, perm: 'system:health' }
    ]
  },
  {
    section: 'Account',
    items: [
      { to: '/admin/account', label: 'Account', icon: UserCircle }
    ]
  }
];
